<template>
    <div>
        <form>
            <div class="row">
                <div class="col-12">
                    <h5>I want the hours for this client to be approved:</h5>
                </div>
                <hr/>
                <div class="col-4">
                    <input type="checkbox" id="workfix" value="workfix" v-model="checkedOpt1"/><label for="workfix">Workfix</label>
                </div>
                <div class="col-4">
                    <input type="checkbox" id="company" value="company" v-model="checkedOpt1"/><label for="company">Company</label>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <input type="checkbox" id="automatic" value="automatic" v-model="checkedOpt2" /><label for="automatic">Automatic</label>
                </div>
                <div class="col-4">
                    <input type="checkbox" id="manual" value="manual" v-model="checkedOpt2" /><label for="manual">Manual</label>
                </div>
            </div>
            
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
    import store from '../../store.js';

    export default {
        data() {
            return {
                comment: '',
                checkedOpt1: [],
                checkedOpt2: []
            };
        },
        async   created() {
            let employment = this.getEmployment

            if(employment !== null && employment.organization !== undefined) {
                this.organization = employment.organization.id
                store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                    if (res.status === 200) {
                        this.flexworkers = res.data.data
                    }
                }).catch((err) => {
                    console.log(err)
                    alert('Unexpected error downloading employments')
                });   
            }
        },
        props: ['index', 'title', 'value', 'name', 'leaveRequest'],
        methods: {
            updateLeaveRequest() {
                this.$emit('saveChanges', this.leaveRequest);
            },
        },
        components: {
        },
        computed: {
            ...mapGetters('employments', [
                'getEmployment'
            ]),
            dateFormatted: {
                get () {
                    return moment(this.leaveRequest.created_at, "YYYY-MM-DD").format('DD/MM/YYYY') + ' (' + this.leaveRequest.hours + ' hours)'
                }, 
                set (value) {
                    this.leaveRequest.created_at = value
                }
            }
        },
        watch: {
        }
    }
</script>

<style lang="scss" scoped>
    label {
        margin-left: 5px;
    }
    h5 {
        font-size: smaller;
        margin-bottom: 2rem;
    }
</style>